import { AxiosResponse } from 'axios';

import client from '../../lib/service/publication.service';
import { EstablishmentImages } from './establishment-images.types';

type Response<T> = { establishment_image: T };
type Params = { file: File; establishment_id: string };

const ESTABLISHMENT_IMAGES = (establishmentId: string) => {
  return `/v1/establishments/${establishmentId}/establishment_images`;
};

const DELETE_ESTABLISHMENT_IMAGES = (establishmentImageId: string) => {
  return `/v1/establishment_images/${establishmentImageId}`;
};

export async function getEstablishmentImages(
  establishmentId: string,
): Promise<EstablishmentImages> {
  const response = await client.get<
    null,
    AxiosResponse<Response<EstablishmentImages>>
  >(ESTABLISHMENT_IMAGES(establishmentId));
  return response.data.establishment_image;
}

export async function postEstablishmentImages(
  params: Params,
): Promise<EstablishmentImages> {
  const { establishment_id, ...body } = params;
  const response = await client.post<
    EstablishmentImages,
    AxiosResponse<Response<EstablishmentImages>>
  >(ESTABLISHMENT_IMAGES(establishment_id), body, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data.establishment_image;
}

export async function deleteEstablishmentImages(
  establishmentImageId: string,
): Promise<EstablishmentImages> {
  return await client.delete(DELETE_ESTABLISHMENT_IMAGES(establishmentImageId));
}
